import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { usuario } from '../models/user';
import { ServerService } from "../server.service";
import {Router} from '@angular/router';
import Swal from 'sweetalert2'


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
///para la sesion


  credentialsInvalid: boolean = false;
  messageError: string = '';
  carnetglobal: Number= 0;
  constructor(private server: ServerService, private router:Router) {

  }

  ngOnInit(): void {

  }

  myForm = new FormGroup({
    carnet: new FormControl("", [
      Validators.required,
   ]),
    userPass: new FormControl("", [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(15)
    ]),

  });


  onSubmit(): void {
    const user = this.myForm.value;

    if(user.carnet === ''  || user.userPass === ''){
      this.credentialsInvalid = true;
      this.messageError = 'Faltan campos a ingresar';
      setTimeout(() => {this.credentialsInvalid = false;},3500);
      return;
    }
    if(this.myForm.valid){
      this.server.postLogin(user.carnet , user.userPass).subscribe((data:any)=> {
      //  console.log("entro a post")
        if(data["status"] === 'no existe'){ //false
         this.messageError = 'Credenciales invalidas';
         this.credentialsInvalid = true;
         setTimeout(() => {this.credentialsInvalid = false;},3500);
         return;
       }

      else {
      const user: usuario = data[0];
       const usuariocompleto:any=JSON.stringify(data[0].nombres)
     //  console.log(data[0].nombres)
       localStorage.setItem('usuario', JSON.stringify(user));
       //este estado indica si está habilitado o deshabilitado
         if(user.estado==0){

             this.messageError = ' Usuario inactivo comuníquese con el administrador';
             this.credentialsInvalid = true;
             setTimeout(() => {this.credentialsInvalid = false;},3500);
             return;

        }
        if(user.banderareseteo==1){
          this.carnetglobal= user.carnet;
         // console.log(user.carnet)
          this.pestañaReseteo(); //call the method for write a new pass and confirm the pass
        }

        //console.log(user.idRol)
       if(user.idRol == 1 ){
         //los guardo en el local storage para despues compararlos en los guards y ver si tienen
         //el rol correspondiente para dejarlos pasar
        localStorage.setItem('rol', "1");
        this.router.navigateByUrl('/admin');
       } else if(user.idRol==2){//profesores
        localStorage.setItem('rol', "2");
         this.router.navigateByUrl('/modulo-docente')
       } else if(user.idRol==3){ //estudiantes
        localStorage.setItem('rol', "3");
         this.router.navigateByUrl('/modulo-estudiante');
       } else if(user.idRol==4){ //coordinadores
        console.log("ENTRO A COORDINADORES");
        localStorage.setItem('rol', "4");
         this.router.navigateByUrl('/modulo-coordinador');
       } else if(user.idRol==5){ //directores
        localStorage.setItem('rol', "5");
         this.router.navigateByUrl('/modulo-director');
       }

   }
     }, error => {

       if (error.status == 401 || error.status == 402){
          // this.messageError = error.error.message;
          this.messageError = 'Problemas de conexion';
       }else{
         this.messageError = 'Credenciales invalidas';
         this.credentialsInvalid = true;

         setTimeout(() => {this.credentialsInvalid = false;},3500);
       }

     })

    }

  }

  //alert para pedir información a la UMMI
alertconInfo(){
  Swal.fire('Envia un correo a:', 'unidaddeanalisis@gmail.com solicitando cambio de contraseña', 'success')
}

//este método despliega la ventana emergente para resetear la contraseña

pestañaReseteo():void{

   Swal.fire({
    title: 'Cambio de contraseña',
    html: ` <form [formGroup]="myForm" (ngSubmit)="onSubmit2("newpass")">
    <div class="input-group form-group">
      <input
      id="newpass" value=""
        type="password"
        class="form-control"
        placeholder="nueva contraseña"
        formControlName="newpass"
        autofocus
      />
    </div>
    <div class="input-group form-group">

      <input
      id="confirmpass"
      type="password"
        class="form-control"
        placeholder="confirmar contraseña"
        formControlName="confirmpass"
      />

    </div>


  </form>
    `,
    confirmButtonText: 'Sign in',
    focusConfirm: false,
    allowOutsideClick: false,


    preConfirm: () => {

      var pass = (<HTMLInputElement>document.getElementById('newpass')).value;
      var confirmpass = (<HTMLInputElement>document.getElementById('confirmpass')).value;



     if (!pass || !confirmpass) {
        Swal.showValidationMessage(`por favor ingrese los 2 campos`)
      }
      if(pass.length <7 ){
        Swal.showValidationMessage(`La contraseña debe tener 7 caracteres`)
      }
      if( pass != confirmpass){
        Swal.showValidationMessage(`Los campos no coinciden`)
      }
      if(pass.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')){
        Swal.showValidationMessage(`La contraseña debe tener min 7 letras,numero,mayúscula y caracter `)
      }
      return { pass: pass}
    }
  }).then((result) => {

    this.resetearContra( this.carnetglobal,result.value.pass);


  /*  Swal.fire(`
     // Login: ${result.value.newpass}
      //Password: ${result.value.password}

    `.trim())*/

    //console.log("fin del metodo");
  })


}
//metodo que recibe desde la ventana nueva la contraseña actual y el carnet que tomó cuando
//se intento loguear
resetearContra(car:any, pass:string):void{

  const bandera:Number=0; //se cambia la bandera al usuario para indicar que ya tiene nueva contraseña
  this.server.putReseteoPass(car,bandera, pass).subscribe((data:any)=> {

    if(data["status"] === 'no existe'){ //false
     this.messageError = 'No se encontró el carnet';
     this.credentialsInvalid = true;//hay error
     setTimeout(() => {this.credentialsInvalid = false;},3500);
     return;
   }
   {
     //si todo estábien
    this.alertCambioPassExitoso();

  }
 }, error => {
  //console.log(error.status)
   if ( error.status === 500 ){   // error.status
      // this.messageError = error.error.message;
      this.credentialsInvalid=true;
      this.messageError = 'el carnet no existe';

   }

   else{
     this.messageError = 'Problemas en la conexión';
     this.credentialsInvalid = true;
     //console.log(error);
     setTimeout(() => {this.credentialsInvalid = false;},3500);
   }

 })

}

alertCambioPassExitoso():void{
  Swal.fire({
    position: 'top',
    icon: 'success',
    title: 'Contraseña actualizada exitosamente',
    showConfirmButton: false,
    timer: 4000
  })
}

encuestaslibres():void{
  this.router.navigateByUrl('/encuestas-libres');
}

}
